<template>
  <div class="pa-6 bg-custom">
    <h2 class="mb-4">
      {{ $vuetify.lang.t('$vuetify.courseManagement.stepCourse.whocansee') }}
    </h2>

    <v-sheet color="white" class="mb-6 pa-6">
      <v-row no-gutters class="mb-3">
        <v-col class="body-1 font-weight-medium text-custom-title">
          {{
            $vuetify.lang.t('$vuetify.courseManagement.whoCanSeeStep.howToShow')
          }}
          <span class="red--text">*</span>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-radio-group
          class="mt-0"
          @change="whoCanSeeChanged"
          v-model="showOnlyUserGroup"
          row
          hide-details
        >
          <v-radio
            :label="
              $vuetify.lang.t(
                '$vuetify.courseManagement.whoCanSeeStep.everyOne'
              )
            "
            :value="false"
          ></v-radio>
          <v-radio
            :label="
              $vuetify.lang.t(
                '$vuetify.courseManagement.whoCanSeeStep.onlySpecificGroups'
              )
            "
            :value="true"
          ></v-radio>
        </v-radio-group>
        <div class="orange--text" v-show="howToShowSaving">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.whoCanSeeStep.savingSetting'
            )
          }}
        </div>
        <div class="green--text" v-show="howToShowSuccess">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.whoCanSeeStep.savingSettingSuccess'
            )
          }}
        </div>
        <div class="red--text" v-show="howToShowFail">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.whoCanSeeStep.savingSettingFail'
            )
          }}
        </div>
      </v-row>
    </v-sheet>

    <v-sheet color="white" class="mb-3 pa-6">
      <v-row no-gutters>
        <v-col lg="11" cols="11">
          <div
            class="body-1 font-weight-medium text-custom-title mb-4 d-flex align-center"
          >
            <v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.whoCanSeeStep.noteTitle'
              )
            }}
          </div>
          <p class="body-2">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.whoCanSeeStep.note1')
            }}
          </p>
          <p class="body-2 mb-0">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.whoCanSeeStep.note2')
            }}
          </p>
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="showOnlyUserGroup">
      <div class="pa-6" v-show="loadingGroupList">
        <v-progress-linear indeterminate color="cyan"></v-progress-linear>
      </div>

      <!-- NEW UI IN CASE WANT TO USE -->
      <!--
      <v-row class="pl-5 pr-5">
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card>
              <v-toolbar flat color="rgb(51, 97, 137)">
                      <v-row>
                      <v-col cols="auto" class="pa-0">
                      <div class="pl-5 pt-4 pb-3" style="color:#FFFFFF; font-weight: bold;">
                        {{ $vuetify.lang.t("$vuetify.courseManagement.whoCanSeeStep.groupList") }}:
                      </div>
                      </v-col>
                      <v-col>
                      <v-text-field
                        outlined
                        class="body-1 pl-4 pr-5"
                        background-color="white"
                        append-icon="search"
                        hide-details="auto"
                        placeholder="Search"
                        style="width:100%;"
                        v-model="groupFilterText"
                        @input="filterGroupList"
                        @change="filterGroupList"
                      >
                      </v-text-field>
                      </v-col>
                      </v-row>
              </v-toolbar>

                  <div class="pl-3 pt-5">
                  <div v-for="(itemGroup, index) in userGroupList" :key="index" v-show="itemGroup.show">
                    <v-row class="px-0 pl-3 pr-6 pb-3">
                      <v-icon v-show="itemGroup.child_User_Group.length != 0">arrow_drop_down</v-icon>
                      <div class="custom-checkbox">
                      <v-checkbox v-show="itemGroup.child_User_Group.length == 0" class="pa-0 ma-0" style="height:30px;"
                                  v-model="selection"
                                  :label="itemGroup.title"
                                  :value="itemGroup._id"
                      ></v-checkbox>
                      </div>
                      <div v-show="itemGroup.child_User_Group.length != 0">
                      {{ itemGroup.title }}
                      </div>
                    </v-row>
                    <ul>
                      <li v-for="child in itemGroup.child_User_Group" :key="child._id" v-show="child.show">
                        <v-row class="px-0 pl-3 pr-6 pb-3">
                          <v-icon v-show="child.child_User_Group.length != 0">arrow_drop_down</v-icon>
                          <div class="custom-checkbox">
                          <v-checkbox v-show="child.child_User_Group.length == 0" class="pa-0 ma-0" style="height:30px;"
                                      v-model="selection"
                                      :label="child.title"
                                      :value="child._id"
                          ></v-checkbox>
                          </div>
                          <div v-show="child.child_User_Group.length != 0">
                          {{ child.title }}
                          </div>
                        </v-row>
                          <ul>
                            <li v-for="child2 in child.child_User_Group" :key="child2._id" v-show="child2.show">
                              <v-row class="px-0 pl-3 pr-6 pb-3">
                                <v-icon v-show="child2.child_User_Group.length != 0">arrow_drop_down</v-icon>
                                <div class="custom-checkbox">
                                <v-checkbox v-show="child2.child_User_Group.length == 0" class="pa-0 ma-0" style="height:30px;"
                                            v-model="selection"
                                            :label="child2.title"
                                            :value="child2._id"
                                ></v-checkbox>
                                </div>
                                <div v-show="child2.child_User_Group.length != 0">
                                {{ child.title }}
                                </div>
                              </v-row>
                            </li>
                          </ul>
                      </li>
                    </ul>
                  </div>
                </div>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card>
              <v-toolbar flat color="rgb(51, 97, 137)">
                  <v-row>
                      <v-col cols="auto" class="pa-0">
                        <div class="pl-5 pt-4 pb-3" style="color:#FFFFFF; font-weight: bold;">
                        {{ $vuetify.lang.t("$vuetify.courseManagement.whoCanSeeStep.selectedGroupList") }}:
                        </div>
                      </v-col>
                      <v-col>
                      <v-text-field
                        outlined
                        class="body-1 pl-4 pr-5"
                        background-color="white"
                        append-icon="search"
                        hide-details="auto"
                        placeholder="Search"
                        style="width:100%;"
                        v-model="selectedFilterText"
                      >
                      </v-text-field>
                      </v-col>
                    </v-row>
              </v-toolbar>
              <div class="pb-5">

                <div v-show="selection.length == 0" align="center" style="height:200px">
                  No group selected
                </div>

                <div v-for="(item, index) in arrayGroup" :key="index">
                  <div v-if="selection.includes(item._id) && item.title.indexOf(selectedFilterText) != -1"  class="ma-8" style="border: 1px solid #d4d4d4; border-radius: 4px;" >
                  <v-row class="ma-0">
                    <v-col class="ma-0">
                    <div style="font-weight: bold;">
                      {{ item.big_title }}
                    </div>
                    <div class="body-2 pt-2" style="color:#9b9b9b;">
                      {{ item.title }}
                    </div>
                    </v-col>
                    <v-col cols="auto" class="ma-0">
                          <v-btn
                            outlined
                            fab
                            style="border-width:0px;"
                            color="#d4d4d4"
                            @click="removeByUser(item)"
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                    </v-col>
                  </v-row>
                  </div>
                </div>
                </div>
          </v-card>
        </v-col>
      </v-row>
      -->

      <!-- OLD UI -->

      <v-row>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card>
            <v-toolbar flat dark color="rgb(51, 97, 137)">
              <v-toolbar-title>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.whoCanSeeStep.groupList'
                  )
                }}:
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-6">
              <div>
                <v-autocomplete
                  v-model="selection"
                  :rules="groupRules"
                  :items="arrayGroup"
                  item-text="title"
                  item-value="_id"
                  append-icon="search"
                  class="text-field-border mb-8"
                  solo
                  flat
                  multiple
                  :hint="selection.length > 0 ? `${selection.length} ` : ``"
                  persistent-hint
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.instructorManagement.instructorList.searchGroups'
                    )
                  "
                >
                  <template v-slot:selection="data">
                    <div
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      small
                    ></div>
                  </template>
                </v-autocomplete>
              </div>

              <div v-for="(group, groupIndex) in arrayGroup" :key="groupIndex">
                <v-checkbox
                  v-model="selection"
                  :label="group.title"
                  :value="group._id"
                  class="py-0 my-0 font-weight-light"
                ></v-checkbox>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card>
            <v-toolbar flat dark color="rgb(51, 97, 137)">
              <v-toolbar-title>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.whoCanSeeStep.selectedGroupList'
                  )
                }}:
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="py-5 px-2">
              <v-autocomplete
                v-model="selection"
                :rules="groupRules"
                :items="arrayGroup"
                item-text="title"
                item-value="_id"
                append-icon
                chips
                small-chips
                multiple
                readonly
                solo
                flat
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    label
                    small
                    @click="true"
                    @click:close="removeByUser(data.item)"
                    >{{ data.item.title }}</v-chip
                  >
                </template>
              </v-autocomplete>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- END OLD UI-->

      <div class="d-flex justify-end mt-4">
        <v-btn
          class="pl-5 pr-5 font-weight-light button-primary white--text"
          @click="updateUserGroupToCourse"
          elevation="0"
          :disabled="disableSaveBtn"
        >
          <v-icon v-if="this.$route.query.id" left>mdi-check</v-icon>
          {{ $vuetify.lang.t('$vuetify.save') }}
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="groupListFail" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.whoCanSeeStep.groupListFailTitle'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.whoCanSeeStep.groupListFailText'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="groupListFail = false">{{
            $vuetify.lang.t('$vuetify.defaultLayout.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="groupListSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.whoCanSeeStep.groupListSuccessTitle'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.whoCanSeeStep.groupListSuccessText'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="groupListSuccess = false"
            >{{ $vuetify.lang.t('$vuetify.defaultLayout.ok') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogConfirmWhoCanSeeEveryone"
      persistent
      max-width="450"
    >
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.whoCanSeeStep.confirmWhoCanSeeEveyoneTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.whoCanSeeStep.confirmWhoCanSeeEveyoneText'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="cancelWhoCanSeeEveryone"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.whoCanSeeStep.confirmWhoCanSeeEveyoneCancelBtn'
              )
            }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="red"
            @click="confirmWhoCanSeeEveryone"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.whoCanSeeStep.confirmWhoCanSeeEveyoneConfirmBtn'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getUserGroup } from '@/service/account/manageUserGroup';

import { getCourseById } from '@/service/course/course';

import { setUserGroupToCourse } from '@/service/account/manageUserGroup';
import checkNameVue from './live/checkName.vue';

export default {
  data: () => ({
    showOnlyUserGroup: false,
    howToShowSaving: false,
    howToShowSuccess: false,
    howToShowFail: false,
    loadingGroupList: false,
    groupListSaving: false,
    groupListSuccess: false,
    groupListFail: false,
    userGroupList: [],
    courseDetails: [],
    courseID: null,
    publicationStatusList: [], //publicationStatusList use _id as index
    dialogConfirmWhoCanSeeEveryone: false,

    //For old UI
    //filterText: "",
    //leafUserGroupList: [],
    //tempLevelForLeafUserGroupList: [],
    //filteredUserGroupList: [],

    selection: [],
    arrayGroup: [],
    selectedFilterText: '',
    groupFilterText: '',
    filteredUserGroupList: [],
  }),
  computed: {
    groupRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.instructorManagement.instructorList.groupRules'
          ),
      ];
    },
    disableSaveBtn() {
      return this.selection.length == 0 || this.groupListSaving;
    },
  },
  methods: {
    async initialize() {
      this.courseID = this.$route.query.id;

      let params = {
        id: this.courseID,
      };

      this.courseDetails = await getCourseById(params);
      this.showOnlyUserGroup = this.courseDetails.user_groups.length != 0;

      if (this.showOnlyUserGroup && this.userGroupList.length == 0)
        this.loadGroupList();

      this.selection = this.courseDetails.user_groups;
    },
    async loadGroupList() {
      this.loadingGroupList = true;
      this.userGroupList = await getUserGroup();
      this.filteredUserGroupList = this.userGroupList;

      //Add showing to show or hide in group list
      for (let i = 0; i < this.userGroupList.length; i++) {
        this.userGroupList[i].show = true;

        //sublist 1
        for (
          let j = 0;
          j < this.userGroupList[i].child_User_Group.length;
          j++
        ) {
          this.userGroupList[i].child_User_Group[j].show = true;

          //sublist 2
          for (
            let k = 0;
            k <
            this.userGroupList[i].child_User_Group[j].child_User_Group.length;
            k++
          ) {
            this.userGroupList[i].child_User_Group[j].child_User_Group[
              k
            ].show = true;
          }
        }
      }

      //change group tree to one line
      this.arrayGroup = [];
      await this.userGroupList.forEach(async (group) => {
        // let arrayGroup = []
        group.child_User_Group.length === 0
          ? await this.arrayGroup.push({
              title: group.title,
              big_title: group.title,
              _id: group._id,
            })
          : null;
        group.child_User_Group.forEach(async (child) => {
          child.child_User_Group.length === 0
            ? await this.arrayGroup.push({
                title: group.title + ' -> ' + child.title,
                big_title: child.title,
                _id: child._id,
              })
            : null;
          child.child_User_Group.forEach(async (lastChild) => {
            await this.arrayGroup.push({
              title:
                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
              big_title: lastChild.title,
              _id: lastChild._id,
            });
          });
        });
      });

      this.loadingGroupList = false;
    },
    whoCanSeeChanged() {
      if (this.showOnlyUserGroup) {
        this.howToShowSuccess = false;
        this.howToShowFail = false;
        if (this.userGroupList.length == 0) this.loadGroupList();
      } else {
        this.dialogConfirmWhoCanSeeEveryone = true;
      }
    },
    async updateUserGroupToCourse() {
      let status = null;
      let valueData = {
        idcourse: this.courseID,
        usergroup: this.selection,
      };

      this.groupListSuccess = false;
      this.groupListFail = false;
      this.groupListSaving = true;

      status = await setUserGroupToCourse(valueData);

      this.groupListSaving = false;

      if (status.code == 403) {
        this.groupListFail = true;
        return 403;
      } else {
        this.groupListSuccess = true;
        return status.code;
      }
    },
    async updateUserEmptyGroupToCourse() {
      let status = null;
      let valueData = {
        idcourse: this.courseID,
        usergroup: [],
      };

      this.howToShowSuccess = false;
      this.howToShowFail = false;
      this.howToShowSaving = true;

      status = await setUserGroupToCourse(valueData);

      this.howToShowSaving = false;

      if (status.code == 403) {
        this.howToShowFail = true;
        return 403;
      } else {
        this.howToShowSuccess = true;
        return status.code;
      }
    },
    cancelWhoCanSeeEveryone() {
      this.dialogConfirmWhoCanSeeEveryone = false;
      this.showOnlyUserGroup = true;
    },
    confirmWhoCanSeeEveryone() {
      this.dialogConfirmWhoCanSeeEveryone = false;
      for (var key in this.publicationStatusList)
        this.publicationStatusList[key] = false;
      this.updateUserEmptyGroupToCourse();
    },
    removeByUser(item) {
      const index = this.selection.indexOf(item._id);
      if (index >= 0) this.selection.splice(index, 1);
    },
    filterGroupList() {
      //For New UI

      //Hide all first
      for (let i = 0; i < this.userGroupList.length; i++) {
        this.userGroupList[i].show = false;

        //sublist 1
        for (
          let j = 0;
          j < this.userGroupList[i].child_User_Group.length;
          j++
        ) {
          this.userGroupList[i].child_User_Group[j].show = false;

          //sublist 2
          for (
            let k = 0;
            k <
            this.userGroupList[i].child_User_Group[j].child_User_Group.length;
            k++
          ) {
            this.userGroupList[i].child_User_Group[j].child_User_Group[
              k
            ].show = false;
          }
        }
      }

      //match keyword with every title
      var tempList = [];
      var tempChild = [];
      var tempChildChild = [];

      for (let i = 0; i < this.userGroupList.length; i++) {
        if (this.userGroupList[i].title.indexOf(this.groupFilterText) != -1) {
          tempList.push(this.userGroupList[i]);
          this.userGroupList[i].show = true; //show matched and children
          for (
            let m = 0;
            m < this.userGroupList[i].child_User_Group.length;
            m++
          ) {
            this.userGroupList[i].child_User_Group[m].show = true;
            for (
              let n = 0;
              n <
              this.userGroupList[i].child_User_Group[m].child_User_Group.length;
              n++
            ) {
              this.userGroupList[i].child_User_Group[m].child_User_Group[
                n
              ].show = true;
            }
          }
          continue;
        } else {
          tempChild = [];
          for (
            let j = 0;
            j < this.userGroupList[i].child_User_Group.length;
            j++
          ) {
            if (
              this.userGroupList[i].child_User_Group[j].title.indexOf(
                this.groupFilterText
              ) != -1
            ) {
              tempChild.push(this.userGroupList[i].child_User_Group[j]);
              this.userGroupList[i].child_User_Group[j].show = true; //show matched and children
              for (
                let l = 0;
                l <
                this.userGroupList[i].child_User_Group[j].child_User_Group
                  .length;
                l++
              ) {
                this.userGroupList[i].child_User_Group[j].child_User_Group[
                  l
                ].show = true;
              }
              continue;
            } else {
              tempChildChild = [];
              for (
                let k = 0;
                k <
                this.userGroupList[i].child_User_Group[j].child_User_Group
                  .length;
                k++
              ) {
                if (
                  this.userGroupList[i].child_User_Group[j].child_User_Group[
                    k
                  ].title.indexOf(this.groupFilterText) != -1
                ) {
                  tempChildChild.push(
                    this.userGroupList[i].child_User_Group[j].child_User_Group[
                      k
                    ]
                  );
                  this.userGroupList[i].child_User_Group[j].child_User_Group[
                    k
                  ].show = true;
                }
              }

              if (tempChildChild.length != 0) {
                tempChild.push({
                  _id: this.userGroupList[i].child_User_Group[j]._id,
                  title: this.userGroupList[i].child_User_Group[j].title,
                  child_User_Group: tempChildChild,
                });
                this.userGroupList[i].child_User_Group[j].show = true;
              }
            }
          }
        }

        if (tempChild.length != 0) {
          tempList.push({
            _id: this.userGroupList[i]._id,
            title: this.userGroupList[i].title,
            child_User_Group: tempChild,
          });
          this.userGroupList[i].show = true;
        }
      }
      this.filteredUserGroupList = tempList;
    },
  },
  async mounted() {
    this.initialize();
  },
};
</script>

<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 40px;
}

.text-field-border {
  border: 1px solid;
  /* border-radius: 8px; */
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

/* Tree View */

ul {
  padding: 0 0 0 0px;
  margin: 1px 0 0 15px;
  list-style-type: none;
}

ul li {
  border-left: 1px dotted black;
  position: relative;
  padding-left: 20px;
}

ul > li {
  padding-bottom: 5px;
}

ul li:before {
  content: '';
  width: 14px;
  position: absolute;
  border-bottom: 1px dotted black;
  left: 0px;
  top: 10px;
}

ul li:last-child {
  border-left: none;
}

ul li:last-child:before {
  border-left: 1px dotted black;
  height: 10px;
  margin-top: -10px;
}

.rotate-90 {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
</style>

<style lang="scss">
.custom-checkbox {
  .theme--light.v-icon {
    color: #4a90e2;
  }
}
</style>